import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";

var _publishColorMap;

import { createStyles } from '@material-ui/core';
import { PublicationStatus } from '@uno/common-cms';
import { colorUsage } from 'stylesheet';
var publishColorMap = (_publishColorMap = {}, _defineProperty(_publishColorMap, PublicationStatus.ONLINE, colorUsage.status.icon.color.online), _defineProperty(_publishColorMap, PublicationStatus.OFFLINE, colorUsage.status.icon.color.offline), _defineProperty(_publishColorMap, PublicationStatus.SCHEDULED, colorUsage.status.icon.color.scheduled), _publishColorMap);
var MuiPublishBadgeOverrideGenerator = createStyles({
  badge: {
    backgroundColor: function backgroundColor(_ref) {
      var publicationStatus = _ref.publicationStatus;
      return publishColorMap[publicationStatus];
    }
  },
  dot: {
    height: '14px',
    width: '14px',
    borderRadius: '50%',
    border: "2px solid ".concat(colorUsage.muiOverride.shadowIcon.border)
  }
});
export { MuiPublishBadgeOverrideGenerator };